import Vue from 'vue'
import { Button, Table ,Icon,Form,Input,FormItem,Checkbox,Select,Option} from 'view-design';
Vue.component('Button', Button);
Vue.component('Table', Table);
Vue.component('Icon', Icon);
Vue.component('Form', Form);
Vue.component('FormItem', FormItem);
Vue.component('Input', Input);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Checkbox', Checkbox);
const noop = () => { }; // 定义一个空函数
noop(); // 调用它不做任何事情